import {
  trackIntegrationConnectFailed,
  trackIntegrationConnectSucceeded,
} from '@/Domain/hooks/Integration/integrationConnectAnalytics';

type CaptureFn = Parameters<typeof trackIntegrationConnectSucceeded>[0];

interface InstagramConnectAttempt {
  scenarioId: string;
  settled: boolean;
}

const popupAttempts = new WeakMap<MessageEventSource, InstagramConnectAttempt>();

export const startInstagramConnectAttempt = (
  popup: Window,
  scenarioId: string,
): InstagramConnectAttempt => {
  const attempt = { scenarioId, settled: false };
  popupAttempts.set(popup, attempt);
  return attempt;
};

export const getInstagramConnectAttempt = (
  source: MessageEventSource | null,
): InstagramConnectAttempt | undefined => (source ? popupAttempts.get(source) : undefined);

export const finishInstagramConnectAttempt = (
  capture: CaptureFn,
  attempt: InstagramConnectAttempt,
  status: 'success' | 'error',
  reasonCode: string | null,
  source: 'popup_callback' | 'status_poll',
): void => {
  if (attempt.settled) return;
  attempt.settled = true;
  const properties = { scenario_id: attempt.scenarioId, source };
  if (status === 'success') {
    trackIntegrationConnectSucceeded(capture, 'instagram', {
      ...properties,
      reason_code: reasonCode,
    });
  } else {
    trackIntegrationConnectFailed(capture, 'instagram', reasonCode ?? 'error', properties);
  }
};
